export class Token {

  constructor (
    public value: string,
    public refreshToken?: string
  ) { }

}
